// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3T-fs","header":"Messages_header__zEMBh"};